export default __webpack_public_path__ + "static/media/kokiran.9c691942.png";